// extracted by mini-css-extract-plugin
module.exports = {"reset":"notifyButton_reset__gntuz","button":"notifyButton_button__iOUfG","fullWidth":"notifyButton_fullWidth__TW01m","fullWidthActive":"notifyButton_fullWidthActive__9euZs"};